export enum SortType {
  External,
  BuiltIn,
  None
}
